import React, { useRef, useState, useEffect } from 'react';
import CryptoJS from "crypto-js";
import { load } from 'recaptcha-v3' //Recaptcha loader

import {
	AlertMessage,
	FormInput_text, FormInput_confirm,
	Button, Spinner,

	CustomPasswordInput, CustomUsernameInput, CustomEmailInput,

	ConfirmationModal
} from "components";

import { useLogin } from "hooks";

import { func_validation, func_url, func_cookie } from 'functions';

import formLogo from 'assets/images/xilnex_official_logo_grey.svg';

import { billingPortalBaseUrl } from "dataflow/billingPortal/constants";

import 'assets/scss/billingPortal/modules/login.scss';



export default function LoginPresentation(props) {

	// Props
	const {
		login_requesting, getUserInfo_requesting, userInfo,

		generateEmailOTP_requesting, generateEmailOTP_status,
		generateEmailOTP_errorMsg,
	} = props;

	// States
	const [recaptchaObj, setRecaptchaObj] = useState(null);
	const [forgotPassword_email, setForgotPassword_email] = useState();
	const [forgotPassword_isEmailValid, setForgotPassword_isEmailValid] = useState();
	const [forgotPassword_isOTPSubmissionAttempted, setForgotPassword_isOTPSubmissionAttempted] = useState();
	const [forgotPassword_alertMsg, setForgotPassword_alertMsg] = useState();
	const [forgotPassword_isAlertMsgVisible, setForgotPassword_isAlertMsgVisible] = useState();
	const [isModalVisible_forgotPassword, setIsModalVisible_forgotPassword] = useState();

	//Recaptcha
	useEffect(() => {
		const loadRecaptcha = async () => {
			try {
				const recaptchaObj = await load('6Ld9j4EpAAAAAFKRQKqjTaL5O6gsiSr67_hKMpQ-');
				setRecaptchaObj(recaptchaObj);
			} catch (error) {
				console.error('Error loading Recaptcha:', error);
			}
		};

		loadRecaptcha();
	}, []);

	// Forgot Password Alert Message
	useEffect(() => {
		if (func_validation.isBooleanTrueNotNullUndefined(generateEmailOTP_status)) {
			setForgotPassword_alertMsg("Please check for email in your inbox as well as the Spam or Junk folder.");
			setForgotPassword_isAlertMsgVisible(true);
		}
		else if (func_validation.isBooleanFalseNotNullUndefined(generateEmailOTP_status) &&
			func_validation.isStringTrimNotEmpty(generateEmailOTP_errorMsg)) {
			setForgotPassword_alertMsg(generateEmailOTP_errorMsg);
			setForgotPassword_isAlertMsgVisible(true);
		}
	}, [generateEmailOTP_requesting]);

	// Hooks
	const {
		email, setEmail,
		isEmailValid, setEmailValidity,
		username, setUsername,
		password, setPassword,
		rememberMe, setRememberMe,
		isFormSubmissionAttempted,

		handleSubmit,

		isAlertMsgVisible, alertMsg, setIsAlertMsgVisible
	} = useLogin({
		...props,
		recaptchaObj: recaptchaObj,
		refreshTokenCookieName: "refresh_token_bp",
		handleOnSuccess: () => {
			let role = func_validation.getObjectPropertyValue(userInfo, "Role");

			if (func_validation.isStringEqual_caseInsensitive(role, "Internal")) {
				let cryptoObj = CryptoJS.SHA3("Message");
				let cookieValue = cryptoObj.toString(CryptoJS.enc.Base64);

				func_cookie.setCookie("in", cookieValue, { path: '/' });
				func_url.historyPushToURL(props, billingPortalBaseUrl + "dashboard");
			}
		},
		authorized_urlRedirection: billingPortalBaseUrl + "dashboard",
		urlRedirectValidation: () => {
			let role = func_validation.getObjectPropertyValue(userInfo, "Role");
			return func_validation.isStringEqual_caseInsensitive(role, "Internal");
		}
	});

	// Forgot Password
	function handleOnConfirm_forgotPassword() {
		if (func_validation.isStringTrimNotEmpty(forgotPassword_email) &&
			props.generateEmailOTP)
			props.generateEmailOTP(forgotPassword_email);
	}

	return (
		<div className={"login d-inline-flex"}>
			{/* Forgot Password Modal */}
			<ConfirmationModal
				className={"login-forgotPassword"}
				description={"Forgot Your Password?"}

				headerClassName={"login-forgotPassword-header"}

				bodyHeader={(
					<AlertMessage
						wrapperclassName={"login-forgotPassword-alertMsg"}
						headerMsg={generateEmailOTP_status ? "OTP is sent to Your Email" : ""}
						message={forgotPassword_alertMsg}
						alertType={generateEmailOTP_status ? "success" : "error"}
						isVisible={forgotPassword_isAlertMsgVisible}
						toggleVisibility={() => { setForgotPassword_isAlertMsgVisible(!forgotPassword_isAlertMsgVisible); }}
					/>
				)}

				input={(
					<CustomEmailInput
						customInputClassName={"login-forgotPassword-input"}

						email={forgotPassword_email}
						handleValueChange={setForgotPassword_email}
						isEmailValid={forgotPassword_isEmailValid}
						handleEmailValidity={setForgotPassword_isEmailValid}

						isFormSubmissionAttempted={forgotPassword_isOTPSubmissionAttempted}

						handleOnEnterPressed={handleOnConfirm_forgotPassword}

						options={{
							isLabelOptional: false,
							isInputOptional: false,
							inputLabel: "Enter your email address"
						}}
					/>
				)}

				cancelButtonText={"Cancel"}
				confirmButtonText={"Confirm"}
				isModalVisible={isModalVisible_forgotPassword}
				updateParentState={setIsModalVisible_forgotPassword}
				handleOnConfirm={handleOnConfirm_forgotPassword}
				isActionLoading={generateEmailOTP_requesting}
			/>

			<div className={"login-formWrapper d-flex justify-content-center align-items-center"}>
				{/* Form */}
				<div className={"login-form d-flex flex-column align-items-center"}>
					<div className={"login-formLogo"}>
						<img
							src={formLogo}
							alt={"Xilnex Logo"}
						/>
					</div>

					<div className="login-title text-center">Billing Portal</div>

					{/* Alert Message */}
					<div className={"login-alertMsgWrapper"}>
						<AlertMessage
							message={alertMsg}
							isVisible={isAlertMsgVisible}
							toggleVisibility={() => { setIsAlertMsgVisible(!isAlertMsgVisible); }}

							isAlertTypeIconHidden isCloseIconHidden
						/>
					</div>

					<div className={"login-inputWrapper"}>
						{/* Username */}
						{/* <CustomUsernameInput
							className={"login-usernameInput"}

							username={username}
							isFormSubmissionAttempted={isFormSubmissionAttempted}

							handleValueChange={setUsername}
							handleOnEnterPressed={handleSubmit}
						/> */}

						{/* Email */}
						<CustomEmailInput
							customInputClassName={"login-emailInput"}

							email={email}
							handleValueChange={setEmail}
							isEmailValid={isEmailValid}
							handleEmailValidity={setEmailValidity}

							isFormSubmissionAttempted={isFormSubmissionAttempted}

							handleOnEnterPressed={handleSubmit}
						/>

						{/* Password */}
						<CustomPasswordInput
							customInputClassName={"login-passwordInput"}

							password={password}
							isFormSubmissionAttempted={isFormSubmissionAttempted}

							handleValueChange={setPassword}
							handleOnEnterPressed={handleSubmit}

							options={{
								isForgotPasswordRequired: true,
								forgotPasswordClassName: "login-passwordInput-forgotPassword",
								handleOnClick_forgotPassword: () => { setIsModalVisible_forgotPassword(true); },
								isSideIconDark: true,
							}}
						/>

						{/* Remember Me */}
						{/* <FormInput_confirm
							customInputClassName={"login-rememberMeWrapper"} 
							inputDescriptionClassName={"login-rememberMeLabel"} 

							isLabelOptional inputName={'rememberMe'} 
							inputStateName={'rememberMe'} inputValue={rememberMe} 
							inputDescription={"Remember Me"}
							propagateValueChange={(stateName, value) => { setRememberMe(value); }}
							isFormSubmissionAttempted={isFormSubmissionAttempted} 
							isErrorOptional 
						/> */}
					</div>

					{/* Login Button */}
					<Button
						className={"login-submitButton"}
						handleOnClick={handleSubmit}

						isDecoration_secondary
					>
						Login {(login_requesting || getUserInfo_requesting) && <Spinner size={0} />}
					</Button>

					{/* Recaptcha */}

				</div>
			</div>
		</div>
	);
}